<template>
  <div class="loader-container">
    <div class="loader rounded-full border-4 border-solid border-primary"></div>
  </div>
</template>

<script>
export default {
  name: 'Loading'
}
</script>

<style lang="scss" scoped>
.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 62px 0;
}

.loader {
  width: 30px;
  height: 30px;
  opacity: 0;
  animation: pulsate 920ms ease-in-out;
  animation-iteration-count: infinite;
}

@keyframes pulsate {
  0% {
    transform: scale(0.1);
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: scale(1.2);
    opacity: 0;
  }
}
</style>
